import React from "react";
import { motion } from "framer-motion";
import { Gift } from "lucide-react";

const BONUSES = [
  {
    img: "/img/bonus-planner.webp",
    title: "Planificador semanal",
    desc: "Plantilla imprimible para organizar tus 7 días en un vistazo.",
    value: "$19 USD",
  },
  {
    img: "/img/bonus-shopping.webp",
    title: "Lista de compras",
    desc: "Listas pre-armadas y listas para tu supermercado.",
    value: "$12 USD",
  },
  {
    img: "/img/bonus-portions.webp",
    title: "Porciones por edad",
    desc: "Guía visual de porciones adecuadas para cada niño.",
    value: "$15 USD",
  },
  {
    img: "/img/bonus-snacks.webp",
    title: "30 snacks saludables",
    desc: "Snacks rápidos y deliciosos para meriendas inteligentes.",
    value: "$14 USD",
  },
];

export default function Bonuses() {
  return (
    <section
      data-testid="bonuses-section"
      id="bonos"
      className="bg-[#FBF4E7] py-20 md:py-32 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#C8A892]/15 px-4 py-2 border border-[#C8A892]/40">
            <Gift className="h-3.5 w-3.5 text-[#C8A892]" />
            <span className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#849983]">
              Bonos exclusivos
            </span>
          </div>
          <h2 className="mt-5 font-serif-display text-4xl md:text-5xl tracking-tight leading-tight text-[#2A302A]">
            Y además recibes <em className="italic">4 regalos</em> incluidos.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#576057]">
            Materiales imprimibles premium pensados para que aplicar el ebook sea aún
            más simple, cada día.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-7">
          {BONUSES.map((b, i) => (
            <motion.article
              key={b.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              whileHover={{ y: -6 }}
              data-testid={`bonus-card-${i}`}
              className="group relative bg-white rounded-[1.75rem] overflow-hidden border border-[#E8DDC9] shadow-[0_18px_50px_rgba(132,153,131,0.12)] hover:shadow-[0_24px_70px_rgba(132,153,131,0.22)] transition-all duration-500"
            >
              <div className="absolute top-4 right-4 z-10 bg-[#849983] text-white text-[10px] tracking-[0.18em] uppercase px-3 py-1 rounded-full font-semibold shadow-md">
                Incluido
              </div>
              <div className="relative h-56 md:h-60 overflow-hidden bg-[#F4EBDE]">
                <img loading="lazy" decoding="async"
                  src={b.img}
                  alt={b.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-serif-display text-2xl text-[#2A302A] leading-tight">
                  {b.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#576057] mt-2.5">
                  {b.desc}
                </p>
                <div className="mt-5 pt-4 border-t border-[#E8DDC9] flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.18em] uppercase text-[#8A948A] font-semibold">
                    Valor
                  </span>
                  <span className="line-through text-[#8A948A] text-sm">
                    {b.value}
                  </span>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
